import * as React from "react";
import { Switch, Route, RouteComponentProps, Redirect } from "react-router";
import { Page } from "../components/Page";
import { RouteHelper } from "../helpers/RouteHelper";
import { CampaignApiModel } from "../apiModels/CampaignApiModel";
import { CampaignEmailEditorModal } from "../modals/CampaignEmailEditorModal";
import { RioIf, RioApiGet, RioApiPost, RioExpandingPanel, RioResources, RioDateHelpers} from "rio.react.all";
import { CampaignPDFDownloadModal } from "../modals/CampaignPDFDownloadModal";
import { CampaignEmailCustomerSelectModal } from "../modals/CampaignEmailCustomerSelectModal";
import { ErrorModal } from "../modals/ErrorModal";
import { HttpErrorHelper } from "../helpers/HttpErrorHelper";
import * as moment from "moment";
import { DataVineGridView } from "../components/GridView/GridView";
import { IGridViewColumn } from "../components/GridView/IGridViewColumn";
import { IGridViewAction } from "../components/GridView/IGridViewAction";

interface ICampaignsProps extends RouteComponentProps {

}

interface ICampaignsState {
    campaigns: Array<CampaignApiModel>;
    downloadPDFCampaignID: number;
    sendClicked: boolean;
    sendCampaignId: number;
    selectedCampaignStartDate: string;
    responseError: string;
}

export class Campaigns extends React.Component<ICampaignsProps, ICampaignsState> {
    constructor(props: Readonly<ICampaignsProps>) {
        super(props);

        this.state = {
            campaigns: [],
            downloadPDFCampaignID: null,
            sendClicked: false,
            sendCampaignId: null,
            selectedCampaignStartDate: null,
            responseError: null
        };
    }

    columns: Array<IGridViewColumn<CampaignApiModel>> = [
        { title: RioResources.find("Title").text, displayValue: (item) => item.title, value: (item) => item.title },
        { title: RioResources.find("CreatedOn").text, displayValue: (item) => RioDateHelpers.toDateFormat(item.createDate, "DD/MM/YYYY"), value: (item) => item.createDate },
        { title: RioResources.find("StartDate").text, displayValue: (item) => RioDateHelpers.toDateFormat(item.startDate, "DD/MM/YYYY"), value: (item) => item.startDate },
        
    ];

    actions: Array<IGridViewAction<CampaignApiModel>> = [
        { resource: RioResources.find("Copy"), onClick: (item) => this.handleCopyClicked(item), hasPermission: true },
        { resource: RioResources.find("Edit"), onClick: item => this.handleDetailsClicked(item), hasPermission: true },
        { resource: RioResources.find("Send"), visible: (item) => !item.startDate || item.startDate >= moment().toISOString(), className: "send", onClick: item => this.handleSendClicked(item), hasPermission: true },
        { resource: RioResources.find("ExamplePDF"), onClick: item => this.handleExamplePDFClicked(item), visible: item => !!item.startDate && item.startDate < moment().toISOString(), hasPermission: true }
    ];

    render() {
        return (
            <Page heading={RioResources.find("Campaigns")}>
                <RioExpandingPanel
                    className="noBackground"
                    disableToggle={true}
                    expandedDefault={true}
                    title={""}
                    actions={[
                        { resource: RioResources.find("New"), onClick: () => RouteHelper.down(this as any, "new"), hasPermission: true }
                    ]}
                >
                    <DataVineGridView<CampaignApiModel>
                        noResults={RioResources.find("NoResultsFound")}
                        columns={this.columns}
                        actions={this.actions}
                        items={this.state.campaigns}
                        rowKey={(item: CampaignApiModel) => item.campaignID}
                    />
                </RioExpandingPanel>

                <RioIf condition={!!this.state.downloadPDFCampaignID} then={
                    <CampaignPDFDownloadModal onClose={() => this.handlePDFDownloadModalClosed()} campaignId={this.state.downloadPDFCampaignID} />
                } />

                <RioIf condition={!!this.state.sendClicked} then={
                    <CampaignEmailCustomerSelectModal campaignId={this.state.sendCampaignId} currentStartDate={this.state.selectedCampaignStartDate} onClose={() => this.handleCloseCustomerSelectModal()} />
                } />

                <RioIf condition={!!this.state.responseError} then={
                    <ErrorModal text={this.state.responseError} onErrorModalClosed={() => this.setState({ responseError: null })} />
                } />

                <Switch>
                    <Route exact path={this.props.match.path} />
                    { /*<Route path={`${this.props.match.path}/new`} render={(props) => <DeviceEditModal onClose={() => this.getDevices()} {...props} />} />*/}
                    <Route path={`${this.props.match.path}/copy/:copyId`} render={(props) => <CampaignEmailEditorModal onClose={() => this.loadData()} copyId={props.match.params.copyId} {...props} />} />
                    <Route path={`${this.props.match.path}/:id`} render={(props) => <CampaignEmailEditorModal onClose={() => this.loadData()} id={props.match.params.id} {...props} />} />
                    <Redirect to={"/campaigns"} />
                </Switch>
            </Page>
        );
    }

    componentDidMount(): void {
        this.loadData();
    }

    loadData(): void {
        RioApiGet.asPromise<Array<CampaignApiModel>>("/api/campaign")
            .then(response => {
                this.setState({
                    campaigns: response
                });
            })
            .catch((response) => {
                var error = HttpErrorHelper.handleHttpError(response, this, null); //handles validator errors if validator passed
                this.setState({ responseError: error });
            });;
    }

    handleCloseCustomerSelectModal() {
        this.setState({
            sendClicked: false,
            sendCampaignId: null,
            selectedCampaignStartDate: null
        });
        this.loadData();
    }

    handleConfirmSend(result: boolean) {
        if (result) {
            RioApiPost.asPromise("/api/CampaignEmail/StartCampaign", this.state.sendCampaignId)
                .then(() => {
                    if (!!Response) {
                        this.setState({
                            sendClicked: false,
                            sendCampaignId: null,
                            selectedCampaignStartDate: null
                        });
                        this.loadData();
                    }
                })
                .catch((response) => {
                    var error = HttpErrorHelper.handleHttpError(response, this, null); //handles validator errors if validator passed
                    this.setState({ responseError: error });
                });;
        } else {
            this.setState({
                sendClicked: false,
                sendCampaignId: null,
                selectedCampaignStartDate: null
            });
        }
    }

    handleSendClicked(campaign: CampaignApiModel): void {
        this.setState({
            sendClicked: true,
            sendCampaignId: campaign.campaignID,
            selectedCampaignStartDate: campaign.startDate
        });
    }

    handleDetailsClicked(campaign: CampaignApiModel): void {
        RouteHelper.down(this as any, campaign.campaignID);
    }

    handleCopyClicked(campaign: CampaignApiModel): void {
        RouteHelper.down(this as any, "copy/" + campaign.campaignID)
    }

    handleExamplePDFClicked(campaign: CampaignApiModel): void {
        this.setState({
            downloadPDFCampaignID: campaign.campaignID
        });
    }

    handlePDFDownloadModalClosed() {
        this.setState({
            downloadPDFCampaignID: null
        });
    }
}